import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import sanitize from 'sanitize-html';
export const FormattedHTMLMessage = ({ id, defaultMessage, description, values, }) => {
    const span = (...chunks) => _jsx("span", { children: chunks.join('') });
    const strong = (...chunks) => _jsx("strong", { children: chunks.join('') });
    const b = (...chunks) => _jsx("b", { children: chunks.join('') });
    const ul = (...chunks) => _jsx("ul", { children: chunks.join('') });
    const li = (...chunks) => _jsx("li", { children: chunks.join('') });
    return (_jsx(FormattedMessage, { values: { span, b, strong, ul, li, ...values }, id: id, defaultMessage: sanitize(defaultMessage !== null && defaultMessage !== void 0 ? defaultMessage : ''), description: description }));
};
